// Convierte "1,2,3" → ["1","2","3"]
export const parseArrayParam = (value) => {
  if (!value) return [];
  return value.split(',');
};

// Convierte "1,2,3" → [1,2,3]
export const parseNumberArrayParam = (value) => {
  if (!value) return [];
  return value.split(',').map(Number);
};

// Convierte "true"/"false" → boolean | null
export const parseBooleanParam = (value) => {
  if (value === null) return null;
  return value === 'true';
};
